import type {DataValue, VerifiedLinkedAgent} from '../types';
import {isVerifiedLinkedAgentLink} from './isVerifiedLinkedAgentLink';

export const isVerifiedLinkedAgent = (
  value: DataValue | undefined,
): value is VerifiedLinkedAgent =>
  isVerifiedLinkedAgentLink((value as VerifiedLinkedAgent).link);
